import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {  CareersComponent} from './careers.component';
import {  InternshipsComponent} from './internships/internships.component';
import { OpportunitiesComponent } from './opportunities/opportunities.component';
// import { NewsComponent } from './news/news.component';

import { routes } from './careers.router';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    routes
  ],
  declarations: [
    CareersComponent,
    InternshipsComponent,
    OpportunitiesComponent
  ]
})
export class CareersModule { }
